export const lang =  {
	str_title: `Chinese`,
	str_index: `Front Page`,
	str_neiye: 'Lobby',
	str_activity: `Activity`,
	str_service: `Customer Service`,
	str_my: `My `,
	str_more: `More`,
	str_save: `Save`,
	str_sure: `Confirm`,
	str_update: `Update `,
	str_serviceName: `Contact Customer Service `,
	str_confirm: `confirm`,
	str_tabs_charge: `Deposit`,
	str_tabs_Withdrawal: `Withdrawal`,
	str_tabs_integral: `Points `,
	str_tabs_activity: `Activity`,
	str_loginBefore: `Login`,
	str_loginBeforeBalance: `Register`,
	str_1_8: `1 minute lottery`,
	str_1_9: `5 minute lottery`,
	str_1_10: `5 minute racing`,
	str_1_11: `1 minute racing`,
	str_1_12: `1 second Sic Bo`,
	str_1_13: `1 minute  Sic Bo`,
	str_1_14: `1 Second Mark Six`,
	str_1_15: `1 minute six lottery`,
	str_1_27: `Color disc 1 second`,
	str_1_28: `Color disc 1 minute`,
	str_1_29: `Fish, shrimp and crab for 1 second`,
	str_1_30: `Fish, shrimp and crab 1 minute`,
	str_1_31: `1 second guessing`,
	str_1_32: `Guess 1 point`,
	str_1_203: `South 1 lottery`,
	str_1_204: `Central 1 Lottery`,
	str_1_205: `North 1 lottery`,
	str_1_100: `Gold Of Luck`,
	str_1_101: `FaFaFa2`,
	str_1_102: `Three Kingdoms`,
	str_1_103: `Lady Vampire`,
	str_1_104: `Treasure Egypt`,
	str_1_1000:'Dragon Fishing',
	str_1_1001:'Star Fishing',
	str_1_1002:'Classic Fishing',
	str_1_1003:'Vintage Fishing',
	str_1_1004:'Arcade Fishing',
	str_100_30300101: `Treasure of the Dragon`,
	str_100_30300501: `Goku Fishing`,
	str_100_30300201: `cash cow`,
	str_100_30300301: `Golden Toad Fishing`,
	str_100_30300401: `Li Kui splits the fish`,
	str_100_30300601: `Dasheng Naohai`,
	str_100_30300701: `tricolor crocodile`,
	str_1_105: `Ho Chi Minh`,
	str_1_106: `copper tower`,
	str_1_107: `Ca Mau`,
	str_1_108: `Ben Tre`,
	str_1_109: `Vung Tau`,
	str_1_110: `Bac Lieu`,
	str_1_111: `Dong Nai`,
	str_1_112: `Can Tho`,
	str_1_113: `Soc Trang`,
	str_1_114: `Xining`,
	str_1_115: `An Giang`,
	str_1_116: `smooth`,
	str_1_117: `Wing Lung`,
	str_1_118: `Binh Duong`,
	str_1_119: `Cha Rong`,
	str_1_120: `Long An`,
	str_1_121: `Binh Phuc`,
	str_1_122: `Hao Jiang`,
	str_1_123: `Tian Jiang`,
	str_1_124: `Jianjiang`,
	str_1_125: `Dalat`,
	str_1_126: `Shunhua`,
	str_1_127: `Fu An`,
	str_1_128: `Dele`,
	str_1_129: `Quang Nam`,
	str_1_130: `Da Nang`,
	str_1_131: `Qinghe`,
	str_1_132: `Ping Ding`,
	str_1_133: `GuangZhi`,
	str_1_134: `Quang Binh`,
	str_1_135: `Gia Lai`,
	str_1_136: `Ninh Thuan`,
	str_1_137: `broad sense`,
	str_1_138: `Delon`,
	str_1_139: `Kunsong`,
	str_1_140: `Ho Chi Minh VIP`,
	str_1_200: `northern`,
	str_1_201: `Lotto 18h25`,
	str_1_202: `Hanoi VIP`,
	str_1_206: `lotto one cent lottery`,
	str_1_300: `Dragon King`,
	str_1_301:`Clash Of The Beasts`,
	str_1_302:`Zeus's Lightning`,
	str_1_303: `Sahara Nights`,
	str_1_304: `Zaida's Fortune`,
	str_2_0: `WM Lobby`,
	str_8_0: `BBIN Lobby`,
	str_10_0: `DG Hall `,
	str_9_0: `SEXY Hall`,
	str_2_101: `Baccarat`,
	str_2_102: `Dragon Tiger`,
	str_2_103: `Roulette`,
	str_2_104: `Sic Bo`,
	str_2_105: `Niu Niu`,
	str_2_106: `Sangong`,
	str_2_107: `Fan Tan`,
	str_2_108: `color disc`,
	str_2_110: `Fish, shrimp crab`,
	str_2_111: `fried golden flower`,
	str_2_112: `Wenzhou Pai Gow`,
	str_2_113: `28 bars`,
	str_2_114: `Andabaha`,
	str_5_Unknown: ``,
	str_5_Soccer: `football`,
	str_5_Basketball: `basketball`,
	str_5_Football: `American football`,
	str_5_IceHockey: `puck`,
	str_5_Badminton: `badminton`,
	str_5_Pool: `Billiards/Snooker`,
	str_5_Motor_Sport: `racing`,
	str_5_Tennis: `tennis`,
	str_5_5_Baseball: `baseball`,
	str_5_Volleyball: `volleyball`,
	str_5_Others: `other`,
	str_5_Golf: `golf`,
	str_5_Boxing: `boxing`,
	str_5_Cricket: `cricket`,
	str_5_Table_Tennis: `table tennis`,
	str_5_Rugby: `rugby`,
	str_5_Handball: `handball`,
	str_5_Cycling: `bike`,
	str_5_Athletics: `Athletics`,
	str_5_Beach_Soccer: `beach soccer`,
	str_5_Futsal: `indoor soccer`,
	str_5_Entertainment: `unique`,
	str_5_Financial: `finance`,
	str_5_Darts: `Darts`,
	str_5_Olympic: `Olympic`,
	str_5_Lacrosse: `lacrosses`,
	str_5_Water_Polo: `water polo`,
	str_5_Winter_Sports: `winter sports`,
	str_5_Squash: `squash`,
	str_5_Field_Hockey: `hockey`,
	str_5_Mixed_Martial_Arts: `MMA`,
	str_5_E_Sports: `E-sports`,
	str_5_Gaelic_Football: `Gaelic Soccer`,
	str_5_Hurling: `板棍球`,
	str_5_Muay_Thai: `Muay Thai`,
	str_5_Aussie_Rules_Football: `Australian Rules Football`,
	str_5_Bandy: `Bandy Ball`,
	str_5_Winter_Olympics: `Winter Olympics`,
	str_6_1: `diamond fruit king`,
	str_6_8: `Sweet Honey`,
	str_6_60: `jungle dance`,
	str_6_2: `Chess Saint`,
	str_6_10: `Five blessings come to the door`,
	str_6_35: `Crazy Nezha`,
	str_6_39: `flying`,
	str_6_57: `beast hegemony`,
	str_6_54: `Fire grass mud horse`,
	str_6_66: `Hot 777`,
	str_6_69: `God of wealth`,
	str_6_70: `million full dragon`,
	str_6_72: `good luck year after year`,
	str_6_74: `treasure bowl`,
	str_6_76: `Want Want Want`,
	str_6_77: `Fire Phoenix`,
	str_6_78: `Apollo`,
	str_6_80: `legendary sea god`,
	str_6_61: `Eat beans every day`,
	str_6_55: `Dragon Legend`,
	str_6_68: `Wukong steals peach`,
	str_6_204: `treasure chest`,
	str_6_83: `queen of fire`,
	str_6_1074: `Cornucopia JP`,
	str_6_1010: `Five Blessings JP`,
	str_6_1067: `Earn Golden Egg JP`,
	str_6_92: `2018 World Cup`,
	str_6_86: `牛逼快跑`,
	str_6_95: `World Cup Sneakers`,
	str_6_96: `football baby`,
	str_6_98: `World Cup All-Stars`,
	str_6_105: `one-handed high jump`,
	str_6_104: `Beachside matchmaking`,
	str_6_122: `Inca Zuma`,
	str_6_131: `Straight God of Fortune`,
	str_6_113: `Flying God of Fortune`,
	str_6_146: `Jiulian Treasure Lamp`,
	str_6_147: `rich flowers`,
	str_6_148: `like a god`,
	str_6_157: `Five-Shaped Boxing`,
	str_6_150: `birthday big hair`,
	str_6_182: `Thor 2`,
	str_6_197: `Panlong Treasure`,
	str_6_199: `happy water festival`,
	str_6_CH03: `bodin`,
	str_6_208: `money tree`,
	str_6_207: `Thai Sic Bo`,
	str_6_209: `little love god`,
	str_6_5: `big gold`,
	str_6_12: `Gold and jade full house`,
	str_6_16: `Five Elements`,
	str_6_36: `night club tycoon`,
	str_6_58: `The Golden Rooster 2`,
	str_6_64: `Zeus`,
	str_6_205: `dance`,
	str_6_81: `Treasure Island`,
	str_6_AS08: `Gold Maya`,
	str_6_AS09: `hollywood pets`,
	str_6_AS10: `lucky 3`,
	str_6_AS17: `Seth's Treasure`,
	str_6_AS18: `Crazy Gummy`,
	str_6_AS19: `christmas story`,
	str_6_AS20: `death queen`,
	str_6_99: `jump higher`,
	str_6_103: `gemstone pairing`,
	str_6_102: `fruit party`,
	str_6_118: `old driver`,
	str_6_130: `steal gold girl`,
	str_6_135: `Straight golden rooster Annunciation`,
	str_6_136: `run beast`,
	str_6_137: `straight dance`,
	str_6_138: `jump over`,
	str_6_139: `Straight burnt chain boat`,
	str_6_140: `Burning Chain Ship 2`,
	str_6_141: `christmas is here`,
	str_6_142: `Vulcan`,
	str_6_143: `Fortune Fuwa`,
	str_6_144: `drill for more`,
	str_6_AT01: `One shot of fishing`,
	str_6_112: `Robber the tomb of the pharaoh`,
	str_6_152: `double fly`,
	str_6_153: `six sugar`,
	str_6_154: `Zeus' father`,
	str_6_160: `God of wealth2`,
	str_6_163: `Nezha comes again`,
	str_6_161: `Hercules`,
	str_6_173: `666`,
	str_6_183: `Wolf Disco`,
	str_6_CA01: `Yaxing CQ9 Live`,
	str_6_4: `Forest Thai Queen`,
	str_6_9: `Zhong Kui Luck Fortune`,
	str_6_13: `Sakura girl`,
	str_6_17: `Lucky Lion`,
	str_6_201: `boxer`,
	str_6_203: `excited up`,
	str_6_79: `chameleon`,
	str_6_89: `Thor `,
	str_6_AS01: `luck boots`,
	str_6_AS02: `crazy circus`,
	str_6_AS03: `how to train dragon`,
	str_6_121: `straight to jump up 2`,
	str_6_124: `Lock Elephant Invincible`,
	str_6_125: `Straight Zeus`,
	str_6_127: `Straight Wusheng`,
	str_6_128: `make big money`,
	str_6_129: `Straight golden rooster Annunciation 2`,
	str_6_133: `Straight Hongfu Qitian`,
	str_6_AS33: `the luck of the pig`,
	str_6_3: `kiss of blood`,
	str_6_7: `to jump up`,
	str_6_15: `Annunciation of the Golden Rooster`,
	str_6_19: `Hot Wheels`,
	str_6_20: `Fafafa`,
	str_6_21: `Legend of the Wild Wolf`,
	str_6_22: `General Affairs Journey to the West Lesson 2`,
	str_6_23: `Gold ingot`,
	str_6_24: `to jump up2`,
	str_6_26: `777`,
	str_6_27: `magic world`,
	str_6_29: `water World`,
	str_6_31: `Wu Sheng`,
	str_6_32: `Detective Di Renjie`,
	str_6_33: `Burning Chain Ship `,
	str_6_34: `Gopher Battle`,
	str_6_38: `Just Dance`,
	str_6_42: `Holmes`,
	str_6_44: `Deluxe Fruit King`,
	str_6_46: `wolf moon`,
	str_6_47: `Pharaoh Treasure`,
	str_6_49: `Lonely Planet`,
	str_6_50: `Hongfu Qitian`,
	str_6_51: `hi blast big circus`,
	str_6_52: `jump high`,
	str_6_202: `dance girl`,
	str_6_67: `Earn Golden Egg `,
	str_6_AB3: `gold Fishing Farm`,
	str_6_59: `summer orangutan`,
	str_6_180: `Annunciation of the Golden Rooster3`,
	str_6_179: `jump high2`,
	str_6_GO169: `Lucky Dragon Small Steel Ball`,
	str_6_185: `Dragon Ball`,
	str_6_186: `queen of fire2`,
	str_6_195: `Wealthy Elephant`,
	str_6_196: `Ten times the golden joy`,
	str_6_200: `run away alice`,
	str_6_AS04: `Wealth Spectre`,
	str_6_108: `straight jump higher`,
	str_6_109: `jump up with one hand`,
	str_6_111: `fly up`,
	str_6_115: `ice queen`,
	str_6_116: `sleepwalking fairyland`,
	str_6_117: `TVXQ`,
	str_6_221: `The Four Heavenly Kings of Di Renjie`,
	str_6_123: `Straight five blessings come to the door`,
	str_6_132: `one more meow`,
	str_6_AT05: `happy fishing`,
	str_6_184: `six capsules`,
	str_6_BT02: `Grab Zhuang Dice Niu Niu`,
	str_6_187: `Wing Chun`,
	str_6_188: `Cricket Mania`,
	str_6_194: `flying dragon in the sky`,
	str_6_BT03: `Grab Zhuang Mi Niu Niu`,
	str_6_AT101: `Mercedes-Benz BMW`,
	str_6_5007: `make a fortune`,
	str_6_5008: `big red`,
	str_6_5009: `havoc in heaven`,
	str_6_206: `sweet crit`,
	str_6_210: `Woo ga scared ga`,
	str_6_212: `Hot Westward Journey`,
	str_6_213: `Mini Roulette`,
	str_6_214: `ninja raccoon`,
	str_6_GO01: `dragon ball coin pusher`,
	str_6_GB1: `321 launch`,
	str_6_GB198: `Color Monkey Bingo`,
	str_6_215: `hot and spicy`,
	str_6_211: `Aquaman`,
	str_6_GB2: `monster hunter`,
	str_6_216: `color disc`,
	str_6_217: `Mahjong Fruit Plate`,
	str_6_177: `boy and magic lamp`,
	str_6_GB6: `Wealthy Little Elephant God`,
	str_6_218: `达拉崩吧`,
	str_6_219: ` Golden Gorilla special`,
	str_6_220: `This market is dead`,
	str_6_222: `Water Thai God Prayer`,
	str_6_GB3: `turn gold coins`,
	str_7_0: `hall`,
	str_7_620: `Texas Hold'em`,
	str_7_720: `28 bars`,
	str_7_830: `Grab Zhuang Niu Niu`,
	str_7_220: `fried golden flower`,
	str_7_860: `Sangong`,
	str_7_900: `Betzhuang Dragon Tiger`,
	str_7_600: `21 o'clock`,
	str_7_870: `Tumblr Niu Niu`,
	str_7_230: `Quick Fried Golden Flower`,
	str_7_730: `grab banker pai gow`,
	str_7_630: `Thirteen waters`,
	str_7_610: `Fighting the Landlord`,
	str_7_910: `Baccarat`,
	str_7_920: `forest dance`,
	str_7_930: `Hundred people cattle`,
	str_7_1950: `10,000 people fried golden flower`,
	str_7_650: `river of blood`,
	str_7_890: `Watch the cards and grab Zhuang Niuniu`,
	str_7_740: `Mahjong for two`,
	str_7_1350: `Wheel of Fortune (cannot be accessed separately)`,
	str_7_1940: `gold shark silver shark`,
	str_7_1960: `Mercedes-Benz BMW`,
	str_7_1980: `100 Sic Bo`,
	str_7_1810: `one-on-one niu niu`,
	str_7_1990: `Fried Niu`,
	str_7_1850: `Bet on rob Zhuang Niuniu`,
	str_7_510: `red envelope fishing`,
	str_7_1355: `Give it a go (cannot access it alone)`,
	str_7_1970: `Five Star Honghui`,
	str_7_1860: `casino poker`,
	str_7_1370: `Hong Kong Stud`,
	str_7_1690: `Blood War Sic Bo`,
	str_7_1890: `fruit machine`,
	str_7_1610: `Lucky Treasure (cannot be accessed separately) `,
	str_7_1930: `Fish, shrimp crab`,
	str_7_8130: `runs fast`,
	str_7_950: `red and black war`,
	str_7_840: `Crazy grab Zhuang Niu Niu`,
	str_7_1710: `Horse war quiz (cannot be accessed separately)`,
	str_7_520: `Li Kui fishing`,
	str_9_MX_LIVE_001: `Classic Baccarat`,
	str_9_MX_LIVE_002: `Baccarat`,
	str_9_MX_LIVE_0039: `9_MX_LIVE_003 insurance Baccarat`,
	str_9_MX_LIVE_006: `Dragon Tiger`,
	str_9_MX_LIVE_007: `Sic Bo`,
	str_9_MX_LIVE_009: `Roulette`,
	str_9_MX_LIVE_010: `red and blue dice`,
	str_10_1: `Baccarat`,
	str_10_3: `Dragon Tiger`,
	str_10_4: `Roulette`,
	str_10_5: `Sic Bo`,
	str_10_7: `Bullfight`,
	str_10_6: `Fan Tan`,
	str_10_8: `competition Baccarat`,
	str_10_11: `fried golden flower`,
	str_10_12: `Speed Sic Bo`,
	str_10_14: `color disc`,
	str_10_15: `Fish, shrimp crab`,
	str_10_51: `Lucky Live 5`,
	str_10_52: `Lucky Live 10`,
	str_12_0: `hall`,
	str_12_620: `Texas Hold'em`,
	str_12_720: `28 bars`,
	str_12_830: `Grab Zhuang Niu Niu`,
	str_12_220: `fried golden flower`,
	str_12_860: `Sangong`,
	str_12_900: `Dragon and Tiger Fight`,
	str_12_600: `21 o'clock`,
	str_12_870: `Tumblr Niu Niu`,
	str_12_230: `Quick Fried Golden Flower`,
	str_12_730: `grab banker pai gow`,
	str_12_630: `Thirteen waters`,
	str_12_610: `Fighting the Landlord`,
	str_12_890: `look at the three Grab Zhuang Niu Niu`,
	str_12_910: `Baccarat`,
	str_12_950: `red and black war`,
	str_12_740: `Mahjong for two`,
	str_12_930: `Hundred people cattle`,
	str_12_510: `fishing battle`,
	str_12_8120: `bloody fight to the end`,
	str_12_920: `forest dance`,
	str_12_8150: `look at the four Grab Zhuang Niu Niu`,
	str_12_8180: `gem match`,
	str_12_8160: `癞子牛牛`,
	str_12_8210: `Give it a go `,
	str_12_8130: `runs fast`,
	str_12_8200: `Pick three from the banker`,
	str_12_8190: `Ten thousand people push the bobbin`,
	str_12_8220: `grab a red envelope`,
	str_12_8230: `Million red envelopes`,
	str_12_940: `gold shark silver shark`,
	str_12_8260: `number one player`,
	str_12_8270: `Happy fried golden flower`,
	str_12_8280: `Friends private room 8281`,
	str_12_8281: `Friend Red Packet Grab Zhuang Niu Niu`,
	str_12_8250: `luxury car drift`,
	str_12_8110: `river of blood`,
	str_12_8310: `God of wealth arrives`,
	str_12_8140: `fruit machine`,
	str_12_8340: `half past ten`,
	str_12_8320: `Black and red plum square 8330`,
	str_12_8330: `speed racing`,
	str_12_8410: `casino poker`,
	str_12_8450: `Sic Bo Grab Zhuang Niu Niu`,
	str_12_8460: `Sic Bo robs Zhuang Sangong`,
	str_12_8470: `Sic Bo Tongbi Sangong`,
	str_12_8480: `Sic Bo red and black single and double`,
	str_12_8490: `Sic Bo bloody fight to the end`,
	str_12_8500: `Big Talk Dice 067`,
	str_12_8510: `big talk dice chai`,
	str_12_8360: `quirky monkey`,
	str_12_8440: `Hong Kong Stud`,
	str_12_8420: `Shangzhuang Hundred people cattle`,
	str_12_8282: `Buddy Room Texas Hold'em`,
	str_12_8550: `Fried Niu`,
	str_12_8600: `overthrow Hu`,
	str_12_8640: `Multiplayer Sic Bo`,
	str_12_8231: `lucky red envelope`,
	str_12_8680: `two people niu niu`,
	str_12_8620: `Dice Niu Niu`,
	str_12_8630: `look on in despair`,
	str_12_8650: `Competition Edition Grab Zhuang Niu Niu`,
	str_12_8690: `Hundred people fried golden flower`,
	str_12_8660: `European Roulette`,
	str_12_8750: `Classic Stud`,
	str_12_8740: `Dou Jinhua`,
	str_12_8820: `Happy fishing fun`,
	str_12_8730: `Fish Leaping Dragon Gate`,
	str_12_8810: `casino war`,
	str_12_8700: `100 Hands Texas Hold'em`,
	str_12_8720: `Hundreds of people shoot the gantry`,
	str_8_3001: `Baccarat`,
	str_8_3003: `Dragon and Tiger Fight`,
	str_8_3005: `Sangong`,
	str_8_3006: `Wenzhou Pai Gow`,
	str_8_3007: `Roulette`,
	str_8_3008: `Sic Bo`,
	str_8_3011: `color disc`,
	str_8_3012: `Niu Niu`,
	str_8_3015: `Fan Tan`,
	str_8_3016: `Fish, shrimp crab`,
	str_8_3017: `insurance Baccarat`,
	str_8_3018: `fried golden flower`,
	str_8_3021: `HiLo`,
	str_8_3025: `Blockchain Baccarat`,
	str_8_3026: `Blockchain Dragon and Tiger Fight`,
	str_8_3027: `Blockchain Insurance Baccarat`,
	str_8_3028: `Blockchain Roulette`,
	str_8_3029: `Blockchain fried golden flower`,
	str_8_3030: `Blockchain three public`,
	str_8_3031: `blockchain Niu Niu`,
	str_8_3032: `Blockchain color disc`,
	str_8_3033: `Blockchain Sic Bo`,
	str_8_3034: `Blockchain fish, shrimp and crab`,
	str_8_3036: `BlockchainHiLo`,
	str_8_3037: `Blockchain Fan Tan`,
	str_8_3038: `Blockchain Wenzhou Pai Gow`,
	str_8_3039: `Blockchain Vietnamese fish, shrimp and crab`,
	str_8_3043: `Blockchain Blackjack Baccarat`,
	str_8_3045: `Blockchain Thai fish, shrimp and crab`,
	str_8_3047: `Blackjack Baccarat`,
	str_8_109001: `football`,
	str_8_109002: `basketball`,
	str_8_109003: `American football`,
	str_8_109004: `tennis`,
	str_8_109005: `baseball`,
	str_8_109006: `ice hockey`,
	str_8_109007: `volleyball`,
	str_8_109008: `E-sports`,
	str_8_109009: `badminton`,
	str_8_109010: `Billiards/Snooker`,
	str_8_109012: `MMA`,
	str_8_109013: `table tennis`,
	str_8_109014: `rugby`,
	str_8_109017: `handball`,
	str_8_109018: `grass hockey`,
	str_8_109019: `racing`,
	str_8_109020: `golf`,
	str_8_109023: `Darts`,
	str_8_109025: `water polo`,
	str_8_109029: `cricket`,
	str_8_109040: `netball`,
	str_8_109051: `Beach Volleyball`,
	str_8_109065: `beach soccer`,
	str_8_109082: `CS GO`,
	str_8_109083: `Dota 2`,
	str_8_109084: `League of legends`,
	str_8_109132: `eSports football`,
	str_8_109133: `eSports basketball`,
	str_8_109147: `King of Glory`,
	str_8_109159: `eSports tennis`,
	str_8_109160: `eSports ice hockey`,
	str_8_109161: `eSports volleyball`,
	str_8_109998: `Mixed clearance`,
	str_8_5005: `Star Wars`,
	str_8_5006: `Staronic`,
	str_8_5008: `monkey climbing tree`,
	str_8_5009: `King Kong Climbing`,
	str_8_5010: `Alien Wars`,
	str_8_5012: `alien hegemony`,
	str_8_5013: `Tradition`,
	str_8_5014: `jungle`,
	str_8_5015: `FIFA2010`,
	str_8_5019: `Fruit Paradise`,
	str_8_5027: `Kung Fu Dragon`,
	str_8_5030: `lucky god of wealth`,
	str_8_5039: `Fish, shrimp crab`,
	str_8_5043: `diamond fruit bowl`,
	str_8_5044: `Star 97II`,
	str_8_5045: `forest dance`,
	str_8_5046: `Fighting soul`,
	str_8_5054: `Craps`,
	str_8_5057: `star 97`,
	str_8_5058: `Crazy Fruit Plate`,
	str_8_5061: `super 7`,
	str_8_5062: `Dragon is on the way`,
	str_8_5063: `Fruit Slots`,
	str_8_5064: `Poker Slots`,
	str_8_5065: `筒子拉霸`,
	str_8_5066: `Soccer Slots`,
	str_8_5067: `Westward Journey`,
	str_8_5068: `Cool So Circus`,
	str_8_5069: `Fruit arena`,
	str_8_5076: `digital wheel`,
	str_8_5077: `fruit wheel`,
	str_8_5079: `3D digital wheel`,
	str_8_5080: `Lotto Wheel`,
	str_8_5083: `diamond train`,
	str_8_5084: `Legend of the Holy Beast`,
	str_8_5088: `Dou Da`,
	str_8_5089: `red dog`,
	str_8_5090: `Annunciation of the Golden Rooster`,
	str_8_5093: `Jin Ping Mei`,
	str_8_5094: `Jin Ping Mei 2`,
	str_8_5095: `cockfighting`,
	str_8_5096: `Five Elements`,
	str_8_5097: `The underwater world`,
	str_8_5098: `Five blessings come to the door`,
	str_8_5099: `golden dog prosperous`,
	str_8_5100: `Chinese Valentine's Day`,
	str_8_5105: `European Roulette`,
	str_8_5106: `three country`,
	str_8_5107: `American Roulette`,
	str_8_5108: `Bonus Roulette`,
	str_8_5109: `French Roulette`,
	str_8_5110: `night shanghai`,
	str_8_5119: `Mysterious Island`,
	str_8_5120: `Nuwa mending the sky`,
	str_8_5121: `Olympus`,
	str_8_5122: `ball fight`,
	str_8_5123: `Classic 21`,
	str_8_5124: `Spain 21 o'clock`,
	str_8_5125: `Vegas 21`,
	str_8_5126: `bonus blackjack`,
	str_8_5127: `PUBG Mobile 5128`,
	str_8_5128: `more fortune and wealth`,
	str_8_5138: `clip pig beads`,
	str_8_5139: `Panda Paradise`,
	str_8_5140: `Beer Fiesta`,
	str_8_5141: `bullfight winner`,
	str_8_5142: `Magic light and phantom sound`,
	str_8_5143: `Candy Party 3`,
	str_8_5144: `Valentine's night`,
	str_8_5145: `step by step high rise`,
	str_8_5146: `Candy Party`,
	str_8_5150: `gem saga`,
	str_8_5151: `Jenga`,
	str_8_5152: `egyptian legend`,
	str_8_5153: `Nine tailed fox`,
	str_8_5154: `Hatsune Attack`,
	str_8_5155: `East China Sea Dragon Palace`,
	str_8_5156: `Zuma Empire`,
	str_8_5157: `Three yuan and four joys`,
	str_8_5159: `Mad Max`,
	str_8_5160: `Thor Thor`,
	str_8_5162: `happy egg`,
	str_8_5163: `Moon Wolf`,
	str_8_5164: `good things come in pairs`,
	str_8_5165: `God of War`,
	str_8_5166: `gourd baby`,
	str_8_5167: `horse to success`,
	str_8_5168: `Golden Rooster Newsletter 2020`,
	str_8_5169: `China's good voice`,
	str_8_5170: `Undersea legend`,
	str_8_5171: `Candy Party _ Speed Edition`,
	str_8_5172: `Partial God of Wealth`,
	str_8_5173: `fortune and treasure`,
	str_8_5174: `The king of electronic music`,
	str_8_5175: `Gypsophila`,
	str_8_5176: `savage warring states`,
	str_8_5177: `lotus`,
	str_8_5178: `steam kingdom`,
	str_8_5181: `Li Li`,
	str_8_5182: `Douyin DJ`,
	str_8_5183: `Reverse Qian Kun`,
	str_8_5184: `Fish Leaping Dragon Gate`,
	str_8_5185: `great harvest`,
	str_8_5186: `Seven Fortunes Announcement`,
	str_8_5187: `ninja master`,
	str_8_5188: `Happy New Year`,
	str_8_5189: `cow luck`,
	str_8_5191: `Full of pig treasures`,
	str_8_5192: `frozen world`,
	str_8_5193: `sweets bar`,
	str_8_5194: `golden god of wealth`,
	str_8_5195: `bee wins wild`,
	str_8_5197: `monster party`,
	str_8_5198: `Halong Bay Mythology`,
	str_8_5199: `street food`,
	str_8_5200: `Fish, shrimp and crab opened`,
	str_8_5204: `2014 FIFA`,
	str_8_5205: `bomb park`,
	str_8_5206: `Golden Tortoise God Crossbow`,
	str_8_5207: `Wuson beats a tiger`,
	str_8_5208: `Bingo Match`,
	str_8_5209: `Prairie Pat`,
	str_8_5210: `Candy Fun`,
	str_8_5211: `doofo God of Wealth`,
	str_8_5212: `Nezha`,
	str_8_5214: `fruit Ninja`,
	str_8_5215: `there is a play tonight`,
	str_8_5216: `Mermaid Secret Treasure`,
	str_8_5217: `Fruit Lucky Star`,
	str_8_5218: `Jungle Adventures`,
	str_8_5402: `night market life`,
	str_8_5404: `Beach Volleyball`,
	str_8_5407: `The Big Red Riding Hood and the Little Wolf`,
	str_8_5601: `uncharted adventure`,
	str_8_5803: `Aztec Treasure`,
	str_8_5805: `Caesar Empire 5810`,
	str_8_5810: `Age of Navigation`,
	str_8_5823: `make a fortune`,
	str_8_5824: `Evil Dragon Legend`,
	str_8_5828: `Tyrannosaurus Rex`,
	str_8_5835: `Happy Year of the Ox`,
	str_8_5837: `Joyful Year of the Monkey`,
	str_8_5839: `Classic Highball 5901`,
	str_8_5901: `serial treasure hunt`,
	str_8_5902: `Candy Party`,
	str_8_5903: `Emperor Qin's Secret Treasure 5904`,
	str_8_5904: `Steam Bomb 5908`,
	str_8_5908: `Candy Party 2`,
	str_8_5909: `Happy Xiao Xiaole`,
	str_8_5910: `magic element`,
	str_8_5912: `Serial Treasure 2`,
	str_8_5888: `JACKPOT`,
	str_8_30599: `fishing expert`,
	str_8_30598: `fishing expert 2`,
	str_8_30593: `golden boy fishing`,
	str_8_38001: `fishing master`,
	str_8_38002: `rich fish farm`,
	str_3_kxyznmbpret1y: `enchanted forest`,
	str_3_qd1fcneqbhgy4: `Hentai`,
	str_3_kdn8ckjqfhsn4: `Tomb of the Pharaoh`,
	str_3_d4fyes4amfxf6: `Phoenix`,
	str_3_a7q65cfts455e: `boxing 2`,
	str_3_cuarr8e1ncebn: `tropical fruit`,
	str_3_96k1k6d3x39za: `Forest Adventure`,
	str_3_x5ikj69a989x6: `gold hunter`,
	str_3_c85wq8o9doqtr: `sorcerer`,
	str_3_hb4cpgc6u6qj4: `western mythology`,
	str_3_wr5axzs95uq7r: `Forest treasure`,
	str_3_cd4rcge6dhqb4: `Day of the Dead`,
	str_3_exesnxb7ge3uy: `haunted house`,
	str_3_pd6rhresnhkbk: `Shaolin`,
	str_3_ezjsgctugyauc: `Big God of Fortune Bingo`,
	str_3_fn6yhwksk7kfk: `Chili Hunter Bingo`,
	str_3_nqyun5dpcjtsy: `online contest`,
	str_3_uafejs6a58xp6: `Bounty Hunter`,
	str_3_jzpssktmfyw1h: `twelve constellations`,
	str_3_7b6c7rcs16kjk: `ocean waves`,
	str_3_uwf5zss55dc7h: `Ye Xian`,
	str_3_3fx69pizs144w: `Lucky Stripes`,
	str_3_6o5emdcnoqyen: `Aztec Temple`,
	str_3_5cx47jffukp3o: `Eight Treasures Money Bag`,
	str_3_gqotnunpejbwy: `Fortune Festival`,
	str_3_b1cnw7mkppwg1: `The killer`,
	str_3_6c5apdrpokbay: `God of wealth prosper`,
	str_3_ipz77igi3mfho: `sweet winter`,
	str_3_b5ggg45epfzg6: `super planet`,
	str_3_93ine65axf986: `boxing `,
	str_3_4eekxm7cistkg: `Dragon's Domain`,
	str_3_y5n8sh5oqf58q: `tiger den`,
	str_3_r8oiyz19mtqir: `lucky clown`,
	str_3_ha1jzrho1gmjq: `Mayan gem`,
	str_3_3erm9p7wssiks: `fire of destiny`,
	str_3_ofy9b9z99u69r: `fire dragon empire`,
	str_3_swt38osdadyhc: `Pirate Saga`,
	str_3_gkubyu4cjibrg: `crazy clown`,
	str_3_rqaonzn7kjjiy: `Four great inventions`,
	str_3_m94wkgy3daxta: `Mystic Sand`,
	str_3_tocki7xk7xwq1: `flame pearl bingo`,
	str_3_cz3wgrounyetc: `Aquaman Bingo`,
	str_3_z7k6mqf3z495a: `Crypto Mania Bingo`,
	str_3_fqho1inijjfwo: `East China Sea Dragon King`,
	str_3_8kzbot4rew7ds: `Journey to the West`,
	str_3_gsttgo1debywc: `Octagonal Gemstone 2`,
	str_3_quofrdenycyyn: `gossip 2`,
	str_3_1wt58azdhdo6c: `fairy all-match`,
	str_3_n1ydr5mncpogn: `Chili Hunter`,
	str_3_gn1bc1kqj7gr4: `gossip `,
	str_3_dxxsh3dfmjpio: `too high Lao Jun`,
	str_3_9ii7s6u5xbhzh: `tree of the world`,
	str_3_wcaadzg74mj7y: `Lady Eagle`,
	str_3_s77hiogba5dhe: `Peach Club`,
	str_3_bzgza4umpbwsh: `The Legend of the Three Princes`,
	str_3_bmr8675wqiigs: `cute witch`,
	str_3_oajk3h9o685xq: `storehouse`,
	str_3_ur8593z8hu17w: `Burning Pearls`,
	str_3_j9nzkkbjfaz1a: `Eye of Horus`,
	str_3_1ru5x5zx7us6r: `God of Lightning`,
	str_3_5ii9zgw5unc3h: `Aquaman's Treasure`,
	str_3_wykepsq659qp4: `four dragons`,
	str_3_q9gi4yybyadoe: `All-match panda`,
	str_3_dkzdo35rcipfs: `China`,
	str_3_ie9eti6w4zfcs: `ancient artifact`,
	str_3_7cz37fritkfao: `lucky chicken`,
	str_3_84igeq3a8r9d6: `gold nugget hunter`,
	str_3_4tyxfmpnwqokn: `Octagonal Gemstone `,
	str_3_soojfuqnaxycn: `Summer of Fruits`,
	str_3_rsjogw1ukbeic: `The Four Tigers of Asia`,
	str_3_3yfmucpss64mk: `Dragon's Flame`,
	str_3_o7f9ih8t6559e: `Empress Wu`,
	str_3_wtupmzq14xepn: `lion dance`,
	str_3_d8cso3u8ct1iw: `Phoenix Reincarnation 888`,
	str_3_7tccifcktqre1: `big tycoon`,
	str_3_4akkze7ywgukq: `crypto mania`,
	str_3_86burqb38a9ua: `Bushido`,
	str_3_8u9r4tj48chd1: `bomb king`,
	str_3_zygj7oqga9nck: `Great God of Wealth`,
	str_3_srd3xusx3ughr: `Enter the KTV`,
	str_3_5ypkuepgw61kk: `Five Elements Water Sending Blessings`,
	str_3_yxdzc9d7qj3zy: `Five Elements of Fire Sending Blessings`,
	str_3_g8awyu1xjtgwr: `red fire crit`,
	str_3_e4ndsc3ogr5dq: `Flame Dragon 88`,
	str_3_m1xn4je4dccb1: `ancient gem`,
	str_3_qn3ynneqbhgy4: `Three tigers dominate`,
	str_3_kqm1cmbpret1y: `Joker Jewelry`,
	str_3_knjnnkjqfhsn4: `888 The Dragon Legend`,
	str_3_d5qfgs4amfxf6: `crazy spin`,
	str_3_ahf5icfts455e: `Lucky Jinfu`,
	str_3_c41bsraonrmbq: `Xuanpu Gala`,
	str_3_99bzr6d3x39za: `What do you belong`,
	str_3_x46x869a989x6: `God of Fortune`,
	str_3_kk8nqm3cfwtng: `Hai Ba`,
	str_3_xkhy6baryz7xs: `Aquaman 2 Ex _ Novice`,
	str_3_qq5ocdypyeboy: `Aquaman 2 Ex _ Beginners`,
	str_3_g54rso4yefdrq: `Aquaman 2 Ex _ Specialist`,
	str_3_ary5bxi9z165r: `Aquaman 2 Ex _ Friends`,
	str_3_b8rzo7uzqt4sw: `Golden Toadfish`,
	str_3_8d7r1okge7nrk: `Dasheng Naohai`,
	str_3_nzkseaudcbosc: `Li Kui splits the fish`,
	str_3_wi17jwsu4de7c: `cash cow`,
	str_3_1jeqx59c7ztqg: `Aquaman 3`,
	str_3_4omkmmpnwqokn: `spongebob`,
	str_3_st5cmuqnaxycn: `happy fishing 5`,
	str_3_ddpg1amgc71gk: `Bug Paradise`,
	str_3_p63ornyjba8oa: `Fisherman's Wharf`,
	str_3_xq9ohbyf9m79o: `Bird king fights for the flying squirrel`,
	str_3_hcu3p8r71kj3y: `Super star`,
	str_3_hf5hx8w9u1q3r: `Book of Covenants Deluxe Edition`,
	str_3_43bx3e7ywgukq: `Dolphin's Pearl Deluxe Edition`,
	str_3_ateqfxp1sqamn: `Dolphin Treasure`,
	str_3_fk9yoi4wkifrs: `50 Golden Lion`,
	str_3_ww3a8wsu4de7c: `summer fruit`,
	str_3_8nsbhokge7nrk: `queen of the nile`,
	str_3_qxoindypyeboy: `Geishas`,
	str_3_xmzfobaryz7xs: `king of the sea`,
	str_3_7f9h9fwz11kaw: `Lady Luck Amulet Deluxe Edition`,
	str_3_ioheiiqk3xrc1: `Book of Covenants`,
	str_3_k9gz4ebbrau1e: `golden double dragon`,
	str_3_aij68ciusna5c: `Columbus`,
	str_3_satj3o6ya8dcq: `Supreme Jewelry`,
	str_3_5m6k9j7rwspjs: `Roman Colosseum`,
	str_3_igg7tisz4ukhw: `Cleopatra`,
	str_3_w4ypzw6o48mpq: `Dragon and Phoenix are auspicious`,
	str_3_xbxy1yegyhnyk: `Forest Island Adventure`,
	str_3_foff4ikkjprr1: `Water Margin`,
	str_3_ef1uyxt98o6ur: `Fortuna Connection`,
	str_3_naagsa5ycfugq: `Ancient Egypt`,
	str_3_i4rc816e388c6: `Robin Hood`,
	str_3_nh9swadbc3use: `High Speed Crown Link`,
	str_3_tqi9778i7mi6o: `Miami`,
	str_3_byz81hmsq748k: `Supreme God of Wealth`,
	str_3_ruufkzk1kpefn: `silver bullet connection`,
	str_3_awn5jciusna5c: `Booty Captain Connect`,
	str_3_3hj4fkfji4z4a: `God of Fortune Fafafa 2`,
	str_3_u17q53q45xcp1: `Legend of the White Snake`,
	str_3_kia1eetdryo1c: `Alice`,
	str_3_9xpa7brfxj7zo: `Mamma Mia`,
	str_3_pirtanombyroh: `barbaric world`,
	str_3_ne4gq55cpitgg: `magic beans`,
	str_3_k3anse3yrrunq: `western sheriff`,
	str_3_79mafnrjt48aa: `Pan Jinlian`,
	str_3_fwria11mjbrwh: `Three Kingdoms Hegemony`,
	str_3_dc7sh3dfmjpio: `Rồng hổ`,
	str_3_3uim5ppkiqwk1: `Fish, shrimp crab`,
	str_3_j3wngk3efrzn6: `Baccarat`,
	str_3_yr1zy9u9xt6zr: `gourd`,
	str_3_hxb3p8r71kj3y: `Sic Bo`,
	str_3_8rqwot18etnuw: `Thor `,
	str_3_9upe5bm4xph81: `Monkey King`,
	str_3_113qm5xnhxoqn: `Aladdin's lamp`,
	str_3_ywozehuuqbazc: `golden island`,
	str_3_bcizh7dipjiso: `Hua Mulan`,
	str_3_55hj8ghaugxj6: `Laughing Maitreya`,
	str_3_jpiuhpbifei1o: `Annunciation of the Golden Rooster`,
	str_3_itzp5iqk3xrc1: `versatile spirit`,
	str_3_7rw3tfwz11kaw: `Arctic treasure`,
	str_3_aodmmxp1sqamn: `fortune and treasure`,
	str_3_o3nxzh9o685xq: `flying dragon in the sky`,
	str_3_ufc6t3z8hu17w: `christmas surprise`,
	str_3_j6j1rkbjfaz1a: `Five Tiger Generals`,
	str_3_9w6aa6u5xbhzh: `Golden Dragon Fafa`,
	str_3_wpu7pzg74mj7y: `auspicious drums make a fortune`,
	str_3_tbfxuhxs694xk: `Fortune Panda`,
	str_3_gd3rn1kqj7gr4: `Queen`,
	str_3_wfo7bzs95uq7r: `Archer`,
	str_3_jsguaktmfyw1h: `Hercules`,
	str_3_dhdirsn3m3xia: `God of wealth arrives`,
	str_3_kf41ymtxfos1r: `sea paradise`,
	str_3_ebudnqj68h6d4: `happy festival`,
	str_3_9mqe9bhroi78s: `Golden Monkey King`,
	str_3_4d5kdkpqi6sk4: `Hot-blooded Adventure`,
	str_3_5864tji8w113w: `Thailand style`,
	str_3_1q36p58phmt6y: `Aladdin`,
	str_3_xtpy4bx49xhx1: `Explore Africa`,
	str_3_69xaiyrbo4dae: `Carnival Night`,
	str_3_z1pc5tp4zqhm1: `silver bullet`,
	str_3_bes8675wqiigs: `Captain Treasure`,
	str_3_bwwza4umpbwsh: `Dance of the Bears`,
	str_3_qieoeyodyyyoc: `Captain Treasure Enhanced Edition`,
	str_3_rh8iwwntk3mie: `dolphin world`,
	str_3_axt5pxf7sk35y: `Crown of Speed`,
	str_3_jbzd1cjsgh4dk: `Sparta`,
	str_3_oqt9p9876m39y: `Aztec Pyramid`,
	str_3_t656f48j75z6a: `great blue ocean`,
	str_3_s6xhiogba5dhe: `football`,
	str_11_102614: `Fafafa2`,
	str_11_102617: `Gigi`,
	str_11_102618: `sexy goddess`,
	str_11_102619: `white lion king`,
	str_11_102623: `Monkey King`,
	str_11_102612: `Poker Party`,
	str_11_102620: `king of high speed`,
	str_11_10211: `rich captain`,
	str_11_10212: `ghost sea`,
	str_11_10213: `drug lord brawl`,
	str_11_802101: `heart of the ocean`,
	str_11_102621: `Captain's Treasure`,
	str_11_102620: `king of high speed`,
	str_11_802601: `Blast Prize 777`,
	str_11_102612: `Poker Party`,
	str_11_20264: `the maid`,
	str_11_802604: `kill zombies`,
	str_11_802606: `Euro 2021`,
	str_11_202613: `big banana`,
	str_11_202611: `Demon Fox`,
	str_11_102615: `Queen of the Southern Kingdom`,
	str_11_102616: `egyptian legend`,
	str_11_10264: `Thunder and lightning seal the god`,
	str_11_702619: `crazy paradise`,
	str_13_7_7001: `Dragon King Fishing`,
	str_13_7_7002: `Dragon King Fishing2`,
	str_13_7_7003: `God of Fortune Fishing`,
	str_13_7_7004: `Five Dragon Fishing`,
	str_13_7_7005: `fishing all the way`,
	str_13_7_7006: `master dragon hunter`,
	str_13_7_7007: `fishing disco`,
	str_13_0_8001: `lucky dragon`,
	str_13_0_8002: `Tang Bohu's Autumn Fragrance`,
	str_13_0_8003: `face change`,
	str_13_0_8004: `Goku`,
	str_13_0_8005: `Llama Adventure`,
	str_13_0_8006: `Taiwan black bear`,
	str_13_0_8007: `Lucky Lin`,
	str_13_0_8014: `Lucky Lion`,
	str_13_0_8015: `Moonlight Secret Treasure`,
	str_13_0_8016: `office worker rhapsody`,
	str_13_0_8017: `new year`,
	str_13_0_8018: `Napoleon`,
	str_13_0_8019: `The Four Treasures of the Study`,
	str_13_0_8020: `Open Sesame`,
	str_13_0_8021: `Golden Banana Empire`,
	str_13_0_8022: `Sparrow Warriors`,
	str_13_0_8023: `Temple of Olympia`,
	str_13_0_8024: `crystal kingdom`,
	str_13_0_8025: `thief thief`,
	str_13_0_8026: `hot dance godfather`,
	str_13_0_8027: `King of Cooking`,
	str_13_0_8028: `Lucky Gold Rats`,
	str_13_0_8029: `Fantasy Candy Island`,
	str_13_0_8030: `mad scientist`,
	str_13_0_8031: `Golden Dumplings`,
	str_13_0_8034: `money man`,
	str_13_0_8035: `Lucky Phoenix`,
	str_13_0_8036: `Dragon King`,
	str_13_0_8037: `magic show`,
	str_13_0_8044: `Country beauty`,
	str_13_0_8046: `Guan Yu`,
	str_13_0_8047: `face change 2`,
	str_13_0_8048: `Open Sesame 2`,
	str_13_0_8049: `Tang Bohu's Autumn Fragrance2`,
	str_13_0_8050: `get rich right away`,
	str_13_0_15001: `Annunciation of the Golden Rooster`,
	str_13_0_15002: `Monkey King`,
	str_13_0_15004: `Fire Bull Array`,
	str_13_0_15005: `Lucky Fuwa`,
	str_13_0_15006: `Inca Empire`,
	str_13_0_15009: `ninja attack`,
	str_13_0_15010: `Panda Chef`,
	str_13_0_15011: `The Legend of Hou Yi`,
	str_13_0_15012: `Five blessings come to the door`,
	str_13_0_15013: `Nine tailed fox`,
	str_13_0_14001: `cockfighting`,
	str_13_0_14002: `Mayan Adventure`,
	str_13_0_14003: `Diaosi Panda`,
	str_13_0_14004: `The Legend of Zelda`,
	str_13_0_14005: `Bag adults`,
	str_13_0_14006: `billionaire`,
	str_13_0_14007: `One Punch Man`,
	str_13_0_14008: `Dragon Warrior`,
	str_13_0_14010: `flying dragon in the sky`,
	str_13_0_14011: `Guardians of the Galaxy`,
	str_13_0_14012: `street fighter`,
	str_13_0_14013: `street fighter`,
	str_13_0_14015: `star wars`,
	str_13_0_14016: `ace agent`,
	str_13_0_14017: `Girls Frontline`,
	str_13_0_14018: `Daji`,
	str_13_0_14019: `Gem Story`,
	str_13_0_14020: `magic milk god`,
	str_13_0_14021: `Money roll money`,
	str_13_0_14022: `mining tycoon`,
	str_13_0_14023: `King of Poker`,
	str_13_0_14025: `Lucky Racing`,
	str_13_0_14026: `make a fortune`,
	str_13_0_14027: `Good Luck 777`,
	str_13_0_14029: `Eastern mythical beast`,
	str_13_0_14030: `Triple King Kong`,
	str_13_0_14033: `Flying Bird Party`,
	str_13_0_14034: `Gou Lai Fu`,
	str_13_0_14035: `Dragon Dance`,
	str_13_0_14036: `Super Cow B`,
	str_13_0_14038: `Egyptian Treasure`,
	str_13_0_14039: `Lucky and Treasure`,
	str_13_0_14040: `Seven Seas Treasure Hunting`,
	str_13_0_14041: `Thor's Hammer`,
	str_13_0_14042: `treasure bowl`,
	str_13_0_14043: `disco bar`,
	str_13_0_14044: `Odd King Kong`,
	str_13_0_14045: `Super Cow B Deluxe Edition`,
	str_13_0_14046: `mining baby`,
	str_13_0_14047: `Regal Brother`,
	str_13_0_14048: `Dragon and tiger all match`,
	str_13_0_14049: `Fruit Blast`,
	str_13_0_14050: `waves`,
	str_13_0_14051: `Li Yue Longmen`,
	str_13_0_14052: `jungle treasure`,
	str_13_0_14053: `waves2`,
	str_13_0_14054: `super drill`,
	str_13_0_14055: `King Kong`,
	str_13_0_14056: `Tyrannosaurus Brothers`,
	str_13_0_14057: `NinjaX`,
	str_13_0_14058: `Flying Elephant Fortune`,
	str_13_0_14059: `Super IV`,
	str_13_0_14060: `Fortune Lantern`,
	str_13_0_14061: `Maya Kim Crazy`,
	str_13_0_14062: `Empire War`,
	str_13_0_14063: `big ternary`,
	str_13_0_14064: `blast party`,
	str_13_0_14065: `prosperous blossoms`,
	str_13_0_14066: `Star Airlines`,
	str_13_0_14067: `White, rich and beautiful girl`,
	str_4_ermj: `Mahjong for two`,
	str_4_blackjack: `21 o'clock`,
	str_4_sangong: `Sangong`,
	str_4_qydz: `All-in Texas`,
	str_4_zjh: `fried golden flower`,
	str_4_blnn: `Niu Niu`,
	str_4_baccarat: `Baccarat`,
	str_4_tbnn: `Tumblr Niu Niu`,
	str_4_hbmj: `card five star`,
	str_4_dzmj: `Volkswagen Mahjong`,
	str_4_gdmj: `Cantonese Mahjong`,
	str_4_hnmj: `Hunan Mahjong`,
	str_4_rbwar: `red and black war`,
	str_4_hzmj: `Hangzhou Mahjong`,
	str_4_mjxzdd: `bloody fight to the end`,
	str_4_mjxlch: `river of blood`,
	str_4_gyzjmj: `Guiyang catching chicken`,
	str_14_1001: `Haibawang`,
	str_14_1002: `eat me one shot`,
	str_14_1003: `Three Immortals Fishing`,
	str_14_1004: `Dragon Hunting Overlord`,
	str_14_1006: `Get rich with one hammer`,
	str_14_1007: `plants vs dinosaurs`,
	str_14_1009: `Three Immortals Split Fish`,
	str_14_2001: `gold medal dragon tiger`,
	str_14_2002: `Hundred people cattle`,
	str_14_2003: `hi money fried golden flower`,
	str_14_2004: `28 bars`,
	str_14_2006: `Baccarat`,
	str_14_2005: `Sangong`,
	str_14_2007: `Thirteen waters`,
	str_14_2008: `Blackjack`,
	str_14_2009: `Texas Hold'em`,
	str_14_2010: `grab a red envelope`,
	str_14_2011: `Grab Zhuang Niu Niu`,
	str_14_3001: `diamond tycoon`,
	str_14_3002: `Fish Leaping Dragon Gate`,
	str_14_3003: `send it up`,
	str_14_3004: `Lions dominate the world`,
	str_14_3005: `Big Secret Treasure`,
	str_14_3006: `egyptian oracle`,
	str_14_3007: `God of wealth arrives`,
	str_14_3008: `The prosperous Tang Dynasty`,
	str_14_3009: `Fortune Lion`,
	str_14_3010: `Big Sage Monkey`,
	str_14_3011: `rob the vault`,
	str_14_3012: `Five holy beasts`,
	str_14_3013: `be happy`,
	str_14_3014: `Arab`,
	str_14_3015: `hungry wolf legend`,
	str_14_3016: `fruit diamond`,
	str_14_3017: `golf`,
	str_14_3018: `Tiger King`,
	str_14_3019: `Zeus god`,
	str_14_3020: `Dracula`,
	str_14_3021: `Pirate King`,
	str_14_3022: `alice`,
	str_14_3023: `hominids`,
	str_14_3024: `Leiba Long`,
	str_14_3025: `king of the circus`,
	str_14_3026: `Turn stone into gold`,
	str_14_3027: `Maya King`,
	str_14_3028: `Fruit Bar`,
	str_14_3029: `Fortune Dragon`,
	str_14_3030: `Golden Monkey Lord`,
	str_14_3031: `Blessed God arrives`,
	str_14_3032: `panda man`,
	str_14_3033: `send immediately`,
	str_14_3034: `777`,
	str_14_3035: `three times monkey`,
	str_14_3036: `Zhao Yun Wushuang`,
	str_14_3037: `Fire Phoenix`,
	str_14_3038: `Lu Ji is unparalleled`,
	str_14_3039: `bao youfa`,
	str_14_3040: `many girls`,
	str_14_3041: `more girls`,
	str_14_3042: `Prosperous God of Wealth`,
	str_14_3043: `Give the cat gold coins`,
	str_14_3044: `Flying Immortals`,
	str_14_3045: `money rat`,
	str_14_3046: `little kitchen lady`,
	str_14_3047: `Pocari`,
	str_14_3048: `Bingguoba`,
	str_14_3049: `golden eye`,
	str_14_3050: `bomb chicken`,
	str_14_3051: `Vegetable Fragrance Family`,
	str_14_3052: `Roman Empire`,
	str_14_3054: `Fist Domination`,
	str_14_3055: `Egyptian Dynasty`,
	str_14_3056: `Magic Dragon Treasure`,
	str_14_3057: `you will fool`,
	str_14_3058: `Red envelopes`,
	str_14_3059: `running ox treasure`,
	str_14_4001: `ladder game`,
	str_14_4002: `Shoot the gantry`,
	str_14_4003: `Gold Rush Egg`,
	str_14_4009: `Ready to go`,
	str_15_2: `Mahjong for two`,
	str_15_3: `Grab Zhuang Niu Niu`,
	str_15_4: `Hundred people cattle`,
	str_15_5: `Dragon King Fishing`,
	str_15_6: `more money and more fortune`,
	str_15_7: `Jing Mi Chu Hand Dezhou`,
	str_15_8: `pusher`,
	str_15_9: `Doubling the Landlord`,
	str_15_10: `Insurance Chu Hand Texas`,
	str_15_11: `bloody fight to the end`,
	str_15_12: `fried golden flower`,
	str_15_13: `must Texas`,
	str_15_14: `Hundreds san gong`,
	str_15_15: `Thirteen waters`,
	str_15_17: `3D fishing`,
	str_15_19: `happy rocking`,
	str_15_20: `Tumblr Niu Niu`,
	str_15_22: `Baccarat`,
	str_15_23: `28 bars`,
	str_15_24: `Guangdong overthrows Hu`,
	str_15_25: `Blackjack`,
	str_15_26: `Cantonese Chicken Pinghu`,
	str_15_33: `Classic Grab Zhuang Niu Niu`,
	str_15_35: `forest dance`,
	str_15_39: `runs fast`,
	str_15_42: `river of blood`,
	str_15_44: `Dragon and Tiger Fight`,
	str_15_45: `Niu Niu Big Eat Small`,
	str_15_47: `happy flipping`,
	str_15_49: `The new version of Doudizhu`,
	str_15_51: `Fish, shrimp crab`,
	str_15_52: `Look at the four pictures to grab Zhuang Niuniu`,
	str_15_53: `San Gong eats small`,
	str_15_55: `Taiwan Mahjong`,
	str_15_56: `fruit cup`,
	str_16_baccarat: `Baccarat`,
	str_16_dragontiger: `Dragon Tiger`,
	str_16_topcard: `football hall`,
	str_16_blackjack: `Blackjack`,
	str_16_scalableblackjack: `Unlimited blackjack`,
	str_16_roulette: `Roulette`,
	str_16_americanroulette: `American Roulette`,
	str_16_instantroulette: `Roulette open from time to time`,
	str_16_craps: `craps`,
	str_16_moneywheel: `Fortune wheel/Dream wheel`,
	str_16_sicbo: `Super Sic Bo`,
	str_101_100: 'GB fishing',
	str_gamesneme_0: `hot`,
	str_gamesneme_1: `general`,
	str_gamesneme_2: `game`,
	str_gamesneme_3: `SLOTS`,
	str_gamesneme_4: `local`,
	str_gamesneme_5: `FISHING`,
	str_gamesneme_6: `chess`,
	str_gamesneme_7: `e-sports`,
	str_gamesneme_all: `all`,

	str_ChannelsName_1: `GB`,
	str_ChannelsName_2: `WM`,
	str_ChannelsName_3: `JOKER`,
	str_ChannelsName_4: `博樂`,
	str_ChannelsName_5: `SBO`,
	str_ChannelsName_6: `CQ9`,
	str_ChannelsName_7: `ไคหยวน`,
	str_ChannelsName_8: `BBIN `,
	str_ChannelsName_9: `SEXY `,
	str_ChannelsName_10: `DG`,
	str_ChannelsName_11: `FUNKY`,
	str_ChannelsName_12: `เลอ ทัวร์`,
	str_ChannelsName_13: `JDB`,
	str_ChannelsName_14: `DS`,
	str_ChannelsName_15: `VG`,
	str_ChannelsName_16: `EVO`,
	str_ChannelsName_101: `GB`,
	str_balanceType_5: `Upgrade VIP Bonus`,
	str_balanceType_6: `Bonus`,
	str_balanceType_7: `Withdrawal `,
	str_balanceType_8: `Deposit `,
	str_balanceType_9: `Transfer`,
	str_balanceType_10: `Give Bonus `,
	str_balanceType_11: `Manual Deposit`,
	str_balanceType_12: `Get Bonus When You Deposit`,
	str_balanceType_13: `Payment Returned `,
	str_balanceType_14: `Activity Of Red Envelope`,
	str_balanceType_15: `Prize Wheel`,
	str_balanceType_16: `Scavenger Hunt`,
	str_balanceType_17: `Deposit `,
	str_balanceType_18: `Transfer Bonus`,
	str_info_title: `Personal Information`,
	str_info_portrait: `Profile`,
	str_info_name: `Name`,
	str_info_phonenumber: `Phone Number `,
	str_info_nickname: `Nickname`,
	str_info_bankcard: `Bank Account `,
	str_info_birthday: `Birthday`,
	str_info_email: `Email`,
	str_maintain_maintain: `System Maintenance `,
	str_maintain_sorry: `System Maintenance Sorry For The Inconvenience`,
	str_activity_title: `Activity`,
	str_activity_tab1: `All `,
	str_activity_tab2: `Latest `,
	str_activity_tab3: `New Member`,
	str_activity_tab4: `VIP `,
	str_activity_tab5: `Daily`,
	str_activitydt_title: `Details Of The Event`,
	str_login_title: `Login`,
	str_login_resSuccess: `Successful Login `,
	str_login_registernew: `Demo `,
	str_login_registernew2: `Register`,
	str_login_forget: `Forgot Password`,
	str_login_Login: `Login`,
	str_register_title: `Register`,
	str_register_form_phonePl: `Please Enter The Phone Number`,
	str_register_form_passwords: `Setting 6_20 Characters Password`,
	str_register_Download: `Download APP`,
	str_register_Enter: `Enter The Game`,
	str_register_message_phone: `Please Enter The Phone Number`,
	str_register_message_code: `Please Enter The SMS Code `,
	str_register_message_password: `Please Enter Your Password`,
	str_register_message_pwdlen: `Password Must Be 6_20 Characters`,
	str_register_message_pwdCon: `Password Incorrect`,
	str_register_message_pwd: `Please Enter Password Twice`,
	str_register_message_agress: `Please Tick Terms and Conditions`,
	str_register_Tick: `Tick To Agreement`,
	str_register_agreement: `Terms and Conditions`,
	str_register_registernow: `Register`,
	str_register_existing: `The Account Already Exists`,
	str_register_resSuccess: `Successfully Registered`,
	str_register_getCode: `Receive SMS Code `,
	str_password_title: `Reset Your Password `,
	str_password_oldpassword: `Please Enter Password`,
	str_password_newpassword: `Please Enter Your New Password`,
	str_password_password: `Please Enter New Password 2 times`,
	str_password_phone: `Please Enter The Phone Number `,
	str_password_code: `Please Enter The SMS Code`,
	str_password_getCode: `Receive SMS Code`,
	str_password_succeeded: `Password Reset Successfully`,
	str_password_Jump: `Redirected To Login Page`,
	str_password_Enter: `Open The Login Page`,
	str_password_Verify: `Verify Phone Number`,
	str_password_rebuild: `Reset Your Password`,
	str_password_complete: `Complete `,
	str_safety_title: `Set The Payment Password`,
	str_safety_pwd: `Reset Account Password`,
	str_safety_payPwd: `Set The Payment Password`,
	str_pwd_title: `Reset Account Password`,
	str_service_title: `Customer Service`,
	str_service_contentOpen: `Register `,
	str_service_contentzhuan: `Make Money And Have Fun `,
	str_service_contentzhuce: `Registration & Consultation`,
	str_service_contentfuwu: `Best Service For You In 24/7`,
	str_my_title: `My`,
	str_my_box_jiaoyi: `Transaction Record`,
	str_my_box_touzhu: `Betting Record`,
	str_my_box_dengji: `Redeem`,
	str_my_box_tuiguang: `Invitation to promote`,
	str_my_balance: `balance `,
	str_my_fanyong: `Commission rebate today`,
	str_my_recharge: `recharge`,
	str_my_withdrawal: `withdraw`,
	str_my_personal: `personal information`,
	str_my_bank: `Bank account`,
	str_my_account: `account safety`,
	str_my_vip: ``,
	str_my_Download: `APP download`,
	str_my_news: `my message `,
	str_my_upgrade: `Detect upgrade`,
	str_my_eliminate: `clear cache`,
	str_my_out: `Sign out`,
	str_withdrawal_binding: `Please select a withdrawal method`,
	str_withdrawal_number: `tail number `,
	str_withdrawal_bankcard: `Debit Card`,
	str_withdrawal_Disable: `User is disabled`,
	str_withdrawal_balance: `balance`,
	str_withdrawal_quota: `Withdrawable amount`,
	str_withdrawal_money: `Withdrawal Amount `,
	str_withdrawal_minimum: `Minimum withdrawal amount`,
	str_withdrawal_withdraw: `Please enter the 6_digit withdrawal password `,
	str_withdrawal_regulations: `Minimum withdrawal amount`,
	str_withdrawal_Withdrawals: `withdraw `,
	str_withdrawal_Please_enter: `Please enter the withdrawal amount`,
	str_withdrawal_Insufficient: `Insufficient balance available for withdrawal`,
	str_withdrawal_greater_than: `Withdrawal amount must be greater than `,
	str_withdrawal_password: `Please enter the withdrawal password`,
	str_withdrawal_success: `Successfully apply for withdrawal`,
	str_withdrawal_set_up: `Please set a payment password before withdrawing money`,
	str_withdrawal_choice: `Please select a bank card`,
	str_integral_title: `Redeem`,
	str_integral_IntegralIncrease: `points increase`,
	str_integral_PointExchange: `Redeem`,
	str_integral_available: `Points Available`,
	str_integral_time: `time`,
	str_integral_lable: `integral `,
	str_spread_title: `Invitation to promote`,
	str_spread_can: `Amount to choose`,
	str_spread_amount: `Transfer amount`,
	str_spread_Cumulative: `Accumulated commission`,
	str_spread_team: `Total number of teams`,
	str_spread_commission: `commission today`,
	str_spread_extension: `Number of people promoted today`,
	str_spread_Promotion: `promotion channel one`,
	str_spread_Promotion2: `Promotion channel two`,
	str_spread_Promotion_link: `Promotional link`,
	str_spread_copy: `Copy link to friend`,
	str_spread_preservation: `Save the invitation QR code`,
	str_spread_Commission: `Commission transfer balance`,
	str_spread_notes: `Remarks: The commission can be withdrawn by transferring the balance to the balance.`,
	str_spread_all: `transfer all`,
	str_spread_success: `Saved successfully`,
	str_spread_fail: `Failed to save `,
	str_spread_alls_all: `All`,
	str_spread_alls_level: `Level `,
	str_spread_alls_search: `Search`,
	str_spread_alls_account: `Account`,
	str_spread_alls_generation: `Level `,
	str_spread_alls_today: `Accumulated Betting`,
	str_spread_alls_team: `Team Size`,
	str_record_trade: `Transaction Record`,
	str_record_betting: `Betting Record `,
	str_record_No_data: `No Data`,
	str_record_searchText_0: `Today `,
	str_record_searchText_2: `Last 3 days `,
	str_record_searchText_6: `Last 7 days `,
	str_record_searchText_29: `Last 30 days`,
	str_record_topText: `filter`,
	str_record_betting_title: `Bet history hetails`,
	str_bettingDetail_pingtai: `platform name`,
	str_bettingDetail_title: `Betting Details`,
	str_bettingDetail_name: `game name`,
	str_bettingDetail_channel: `game type`,
	str_bettingDetail_orderStatus: `Order Status`,
	str_bettingDetail_gameType: `Order Status`,
	str_bettingDetail_dateDesc: `betting time`,
	str_bettingDetail_accountDesc: `Total bet amount`,
	str_bettingDetail_lotteryAccount: `winning amount`,
	str_bettingDetail_orderNo: `bet number`,
	str_bettingDetail_state0: `Settled`,
	str_bettingDetail_state1: `betting`,
	str_bettingDetail_state2: `Invalid bet`,
	str_card_title: `Bank card`,
	str_card_bankName: `Bank`,
	str_card_bankNamePl: `Please select a bank card`,
	str_card_bankNo: `account number`,
	str_card_zskNo: `Quick transfer`,
	str_card_zskNo1: `Please enter the quick transfer account number`,
	str_card_bankNoPl: `Please enter bank card account number`,
	str_card_name: `Name`,
	str_card_namePl: `Please enter English name`,
	str_card_tips: `Please be consistent with your real name, otherwise it will affect the withdrawal
Once the information is sent, it can only be modified through customer service. `,
	str_card_default: `Bank card`,
	str_card_choice: `Please select a bank`,
	str_card_Enterbankcard: `Please enter bank name to search`,
	str_card_search: `search`,
	str_card_binding: `bind`,
	str_record_trading_title: `Transaction Details`,
	str_record_trading_type: `type`,
	str_record_trading_orderNo: `single number`,
	str_record_trading_dateTime: `time`,
	str_record_trading_desc: `Review Notes`,
	str_record_trading_progress: `current progress`,
	str_record_trading_copysuccess: `Copy successfully`,
	str_record_trading_Recharge: `successful recharge`,
	str_code_500: `The system is busy`,
	str_code_4000: `not logged in`,
	str_code_4001: `Parameter error`,
	str_code_4002: `Verification code error`,
	str_code_4003: `account or password incorrect`,
	str_code_4004: `no such method`,
	str_code_4005: `User does not exist`,
	str_code_4006: `Mobile number not verified`,
	str_code_4007: `The mobile number has already been registered`,
	str_code_4008: `This card is not supported`,
	str_code_4009: `The user has bound a bank card`,
	str_code_4010: `Game login failed`,
	str_code_4011: `birthday bound`,
	str_code_4012: `Real name already bound`,
	str_code_4013: `Unbound bank card`,
	str_code_4014: `The selected bank card is inconsistent with the bound bank card`,
	str_code_4015: `Account has been disabled`,
	str_code_4016: `Failed to claim the offer`,
	str_code_4017: `The original password was entered incorrectly`,
	str_code_4018: `old and new passwords are the same`,
	str_code_4019: `Withdrawal password wrong`,
	str_code_4020: `The old and new withdrawal passwords are the same`,
	str_code_4021: `Withdrawal password not bound`,
	str_code_4022: `The real name filled in is inconsistent with the binding real name`,
	str_code_4023: `Event is not active`,
	str_code_4024: `Failed to claim the offer`,
	str_code_4025: `no such event`,
	str_code_4026: `The event has not been redeemed yet`,
	str_code_4027: `already received this offer`,
	str_code_4028: `You already have an account to claim the offer`,
	str_code_4029: `Recharge conditions not met`,
	str_code_4030: `No offer to claim`,
	str_code_4031: `Not enough points`,
	str_code_4032: `task not completed`,
	str_code_4033: `Received discount`,
	str_code_4034: `Offer has expired`,
	str_code_4035: `It's not time to pick up`,
	str_code_4036: `Received a discount today`,
	str_code_4037: `No discount available`,
	str_code_4043: `No offers to transfer in`,
	str_code_4044: `Too many unpaid orders, please contact customer service`,
	str_code_4045: `Failed to send verification code, please contact customer service`,
	str_code_4046: `You have outstanding withdrawals, please wait for processing`,
	str_name_title: `actual name`,
	str_name_name: `actual name`,
	str_name_namePl: `please enter your real name`,
	str_name_tips: `The real name should be consistent with the bank card, otherwise it will affect the withdrawal. Once the information is sent, it can only be modified through customer service.`,
	str_nick_title: `Nickname`,
	str_nick_nick: `Nickname`,
	str_nick_nickPl: `Please Enter A Nickname`,
	str_email_title: `Bind Email Account`,
	str_email_email: `Email`,
	str_email_emailPl: `Please Enter A Valid Email`,
	str_facebook_title: `Bind Facebook Account`,
	str_facebook_facebook: `Facebook`,
	str_facebook_facebookPl: `Please Enter Facebook Account`,
	str_line_title: `Bind Line Account`,
	str_line_line: `Line `,
	str_line_linePl: `Please Enter Line Account `,
	str_birthday_title: `Bind Birthday `,
	str_birthday_birthday: `Birthday`,
	str_birthday_birthdayPl: `Please Select Your Birth Date`,
	str_vipList_title: `Get rewarded`,
	str_vipList_tip: `Upgrade bonus`,
	str_vipList_yuan: `Yuan`,
	str_vipList_yi: `Received`,
	str_vipList_now: `Get it now`,
	str_viprules_title: `VIP Law`,
	str_viprules_tip: `Upgrade Rules`,
	str_viprules_e: `Upgrade bonus`,
	str_viprules_leiji: `bet amount`,
	str_vip_title: `recharge`,
	str_vip_content_current: `Current bet`,
	str_vip_content_difference: `Still missing`,
	str_vip_content_Bet: `Bet to upgrade`,
	str_vip_content_receive: `Get upgrade bonus`,
	str_vip_content_Betamount: `Bet amount (yuan)`,
	str_vip_content_Recharge: `Recharge (yuan)`,
	str_vip_content_Promotion: `Upgrade bonus (yuan)`,
	str_vip_content_vip: `VIP Privileges`,
	str_vip_content_see: `see all`,
	str_vip_content_Promotiongift: `Upgrade bonus`,
	str_vip_content_More: `more perks`,
	str_vip_content_wait: `Keep stable`,
	recharge_title: `recharge`,
	str_recharge_channel: `way`,
	str_recharge_choice: `option`,
	str_recharge_zfb: `Alipay`,
	str_recharge_payment: `payment methods`,
	str_recharge_money: `Deposit amount`,
	str_recharge_Please: `Please enter deposit amount`,
	str_recharge_amount: `Recharge place`,
	str_recharge_yuan: `Yuan`,
	str_recharge_immediately: `Recharge now`,
	str_recharge_order: `numerical order`,
	str_recharge_platform: `Payment Platform`,
	str_recharge_username: `account name`,
	str_recharge_account: `account`,
	str_recharge_copy: `Copy`,
	str_recharge_payments: `payment confirmation`,
	str_recharge_dcWallet: `virtual currency wallet`,
	str_recharge_Tips: `Give advice:`,
	str_with_title: `Preparation`,
	str_balance_title: `Balance details`,
	str_balance_total: `Total balance (yuan)`,
	str_avatar_title: `Avatar`,
	str_lucky_title: `Lucky offer`,
	str_lucky_namePl: `Please enter promo code`,
	str_lucky_tp: `Congratulations on winning the lucky prize`,
	str_lucky_info: `Please contact customer service to get a discount code`,
	str_lucky_bot: `Offer up to 5866 yuan`,
	str_lucky_tips: `Earn bonus after depositing in game`,
	str_lucky_resSuccess: `Received successfully`,
	str_rebate_title: `sale off`,
	str_rebate_btn: `VIP discount`,
	str_rebate_lingqu: `claim bonus`,
	str_rebate_footTip: `Get your bonus today`,
	str_rebate_table: `time, game name, shuffle amount, discount rate, rebate bonus, status`,
	str_vip_rebate_title: `VIP hoa hồng`,
	str_vip_rebate_vip: `VIP level`,
	str_log_titleW: `Withdrawal records`,
	str_log_titleR: `Recharge record`,
	str_log_amount: `Balance`,
	str_log_Application: `application time`,
	str_log_Audit: `Review time`,
	str_log_state: `status`,
	str_log_Tobepaid: `Get paid`,
	str_log_success: `success`,
	str_log_Paid: `Paid`,
	str_log_close: `order is closed`,
	str_log_launch: `Send payment`,
	str_log_WithdrawalSucceeded: `Payment success`,
	str_log_WithdrawalFailed: `Can't withdraw`,
	str_log_remarks: `Comment`,
	str_log_nothing: `No`,
	str_log_shenhe: `is considering`,
	str_rush_title: `Daily first charge`,
	str_phone_title: `Modify phone`,
	str_lower_title: `All lower level`,
	str_achievememt_title: `team performance`,
	str_achievememt_account: `Account`,
	str_achievememt_directly: `directly`,
	str_achievememt_achievement: `Achievement`,
	str_achievememt_newly: `Add`,
	str_achievememt_team: `Team `,
	str_achievememt_income: `Income`,
	str_achievememt_commission: `Commission `,
	str_achievememt_detailed: `Detail`,
	str_achievememt_item: `Time Limit `,
	str_achievememt_user: `User Name`,
	str_achievememt_date: `Date `,
	str_memberdetails_title: `Member Profile`,
	str_team_title: `Team Bonuses`,
	str_message_title: `New`,
	str_message_system: `System`,
	str_message_business: `News `,
	str_message_Loading: `Loading `,
	str_message_No: `No More `,
	str_msg_title: `Details `,
	str_game_list_title: `Slots`,
	str_update_edition: `Edition `,
	str_update_Updating: `Updating`,
	str_update_progress: `Progress`,
	str_update_fail: `Fail `,
	str_update_determine: `Determine`,
	str_index_top: `GB `,
	str_top_content: `Live entertainment, sports betting and electronic entertainment are all in one hand`,
	str_top_xiazai: `Download`,
	str_Totalbet: `Total bets`,
	str_Totalwinorlose: `total win`,
	str_record_platform: `platform`,
	str_record_platform: `valid bet`,
	str_winorlose: `winning or losing`,
	str_record_zhudan: `Betting`,
	str_trade_all: `all`,
	str_trade_caijin: `winnings`,
	str_trade_tixian: `cash out`,
	str_trade_chongzhi: `recharge`,
	str_trade_fanyong: `rebate`,
	str_trade_erdu: `Quota conversion`,
	str_trade_shoudong: `Manual recharge`,
	str_trade_cengjin: `Recharge bonus`,
	str_trade_tuihui: `Withdrawal and return`,
	str_spread_suoyou: `all subordinates`,
	str_spread_tuandui: `Team achievement`,
	str_spread_fanyong: `Commission rebate ratio`,
	str_qukuan: `Please enter the login password`,
	str_qukuan_mima: `Please enter the original withdrawal password`,
	str_login_forget2: `If you forget your login password`,
	str_chongzhi: `reset Password`,
	str_qukuanmima: `If you forget the original withdrawal password, please`,
	str_lianxi: `Contact Customer Service`,
	str_wenxin: `Friendly reminder`,
	str_card_tishi: `Members can only bind one bank card account and one FPS account, and the name of the account holder must be the same. If you need to modify it after binding, please contact our 24-hour online customer service.`,
	str_service_contentchongzhi: `Recharge consultation`,
	str_my_zhanghao: `Account number`,
	str_go_index: `Go Home`,
	str_tiem_chaxun: 'Query days cannot be greater than 30 days',
	str_Platform_name: 'Platform name',
	str_Bet_amount: `Bet amount`,
	str_Other_games: `Other games`,
	str_Reset: 'Reset',
	str_less_than: 'The query interval must be less than 30 days',
	str_What_level: `What level`,
	str_fishing: 'fishing',
	str_Electronics: 'Electronics',
	str_Chess_cards: 'Chess and cards',
	str_lottery: `lottery`,
	str_Real_person: `Real person`,
	str_Sports: `Sports`,
	str_Copy_link: `Copy connection to friends`,
	str_withdrawal_mode: 'Please select withdrawal method',
	str_bank_card: 'Bank card',
	str_vip_content_betRecharge: 'Current recharge',
	str_vip_content_Bet2: 'Recharge to upgrade to',
	str_vip_leves: 'Upgrade must meet any of the following conditions',
	str_vip_leves2: 'There are two conditions for upgrading',
	str_first_charge: 'Todays first charge amount:',
	str_received: 'Todays bonus:',
	str_Require: 'First deposit amount requirement',
	str_give_away: 'Gift bonus',
	str_xima_fanli: 'Shuffle code rebate',
	str_maintain: 'This platform is under maintenance, please change to another platform to play the game',
	str_rebate_table1: `Time`,
	str_rebate_table2: `Game name`,
	str_rebate_table3: `Code washing quantity`,
	str_rebate_table4: `Return water ratio`,
	str_rebate_table5: `Return water color gold`,
	str_rebate_table6: `Status`,
	str_wan: '',
	// str_one_chong: '1stTop-up',
	str_one_chong: 'first charge',
	str_recharge_chongzhi: 'top up slot',
	str_recharge_card: 'payment card number',
	str_xima_shouming: 'Event Description',
	str_xima_1: '1. First daily recharge sequence greater than 100.00 and Bonus will be awarded ',
	str_xima_2: '2. The higher the deposit bonus. The more bonuses See table for details ',
	str_xima_3: '3. Event refresh time, 0:00 daily. ',
	str_xima_4: '4. Claims log can be viewed in transaction log ',
	str_qianbao_guanli: 'Wallet Management',
	str_massge_my: 'My Messages',
	str_go_login: 'Go To Login',
	str_no_login: 'Not Signed In',
	str_one_chong: 'First Billing',
	str_xima_5: '2 Discount Codes Daily Clock Rebate Calculator. On the previous days bet',
	str_xima_6: '2. Rebate ratio "50" means 50 for every 10,000 valid bets',
	str_rebate_wei: 'Not up to standard',
	str_vip_rebate_title2: 'Event Description',
	str_download_copy: 'Copy link',
	str_tigong: 'Provide you with the best mobile client,',
	str_suixing: 'Mobile travel, let you have fun',
	str_baocun: 'Save QR code',
	str_balance:'Balance',
	str_colose: 'Close',
	str_index:'Home',
	str_about:'About us',
	str_service:'Game Product Service',
	str_service_desc:'Thank you for using SWG game products and services, SWG provides professional video games, we have rich game experience, and more than 50 game APIs bring you the best game experience!',
	str_multivariate:'Diverse Entertainment',
	str_multivariate_desc:'Covering slot machines, fishing machines, small games, electronic lottery, and other types of electronic game development, especially good at slot machines, fishing machine games.',
	str_scroll_tips:'Swipe up as instructed',
	str_loading:'Loading',
  str_card_point:'points',
  str_card_bj_blackjack:'Black Jack',
  str_card_bj_5dragon:'5 Dragons',
  str_card_bj_bust:'Bust',
  str_balloon_size:'Balloon size',
  str_balloon_result:'Result',
  str_jump_height: 'Jump Height',
  str_jump_amount: 'Jump Amount',
  str_special_Games: 'Special Games:',
  str_three_yuan: 'Zhong Fa Bai',
  str_luckiest_man: 'Fourth birthday',
  str_lightning_jet: 'Lightning Jet',
  str_none:'none',


}



// WEBPACK FOOTER //
// ./src/VueI18n/language-en.js